export default "__VITE_ASSET__0e05bcdb__"